/**
 * A numeric column heading that shortens itself on a phone.
 *
 * These columns are sized by their HEADING, not by their data: "GAMES" is
 * 52px of a 360px table and the figures under it are two characters. Four
 * such headings were most of the reason the squad table and the player stats
 * board ran off the right edge of a 390px screen, and what scrolled off was
 * whatever came last.
 *
 * So the word is kept where there is room and a letter is used where there is
 * not — the shorthand every league table uses, and the same convention the
 * standings on this site already follow with P, PTS, SD and GD.
 *
 * THE ACCESSIBLE NAME IS ON THE TH, not on either span, and both spans are
 * hidden from assistive technology. Swapping two spans with `display: none`
 * would otherwise leave a screen reader announcing "G" at one width and
 * "Games" at another, or — if the visible one were also aria-hidden —
 * announcing nothing at all. One `aria-label` is read the same at every size.
 */
export default function NumHead({
  full,
  abbr,
  title,
}: {
  /** The word, used wherever there is room for it. */
  full: string;
  /** The letter or two used on a narrow screen. */
  abbr: string;
  /** The longer explanation, for a hover or a long press. */
  title?: string;
}) {
  return (
    <th className="num" aria-label={full} title={title ?? full}>
      <span className="th-full" aria-hidden="true">{full}</span>
      <span className="th-abbr" aria-hidden="true">{abbr}</span>
    </th>
  );
}
